module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc4-221d47971b7998ec4abff09ff9a72afa.jpg";